import React from "react";
import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import { MemoryRouter } from "react-router-dom";
import AutomationExecutionLog from "./AutomationExecutionLog";

const mockUseAutomationExecutions = jest.fn();
const mockUseAutomationExecution = jest.fn();
const mockUseAutomationRules = jest.fn();

jest.mock("../../../providers/WorkspaceProvider", () => ({
  useWorkspaceContext: () => ({
    workspace: { id: "workspace-1" },
  }),
}));

jest.mock("../hooks/useAutomationRules", () => ({
  useAutomationExecutions: (...args: unknown[]) => mockUseAutomationExecutions(...args),
  useAutomationExecution: (...args: unknown[]) => mockUseAutomationExecution(...args),
  useAutomationRules: (...args: unknown[]) => mockUseAutomationRules(...args),
}));

describe("AutomationExecutionLog", () => {
  beforeEach(() => {
    mockUseAutomationExecutions.mockReturnValue({
      executions: [
        {
          id: "exec-1",
          rule_id: "rule-1",
          trigger_type: "ROW_CREATED",
          triggered_by: "user-1",
          triggered_at: "2026-08-30T09:00:00Z",
          row_id: "row-1",
          table_id: "table-1",
          old_values: null,
          new_values: null,
          status: "condition_not_met",
          actions_results: [],
          started_at: "2026-08-30T09:00:00Z",
          completed_at: "2026-08-30T09:00:01Z",
          duration_ms: 1,
        },
        {
          id: "exec-2",
          rule_id: "rule-1",
          trigger_type: "ROW_CREATED",
          triggered_by: "user-1",
          triggered_at: "2026-08-30T09:05:00Z",
          row_id: "row-2",
          table_id: "table-1",
          old_values: null,
          new_values: null,
          status: "no_matches",
          actions_results: [],
          started_at: "2026-08-30T09:05:00Z",
          completed_at: "2026-08-30T09:05:01Z",
          duration_ms: 1,
        },
      ],
      loading: false,
      error: null,
      refresh: jest.fn(),
    });
    mockUseAutomationExecution.mockReturnValue({
      execution: null,
      loading: false,
      error: null,
    });
    mockUseAutomationRules.mockReturnValue({
      rules: [{ id: "rule-1", name: "Notify on submit" }],
      loading: false,
      error: null,
      refresh: jest.fn(),
    });
  });

  it("surfaces the new non-acting execution states in the list", () => {
    render(
      <MemoryRouter>
        <AutomationExecutionLog />
      </MemoryRouter>,
    );

    expect(screen.getByText("Execution log")).toBeInTheDocument();
    expect(screen.getAllByText("Condition not met").length).toBeGreaterThan(0);
    expect(screen.getAllByText("No matches").length).toBeGreaterThan(0);
  });
});
